import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';
import icons from 'styles/icons/icons.scss';
import formStyles from 'styles/forms.scss';
import styles from './SwapBox.scss';


class SwapBox extends Component {
    render() {
        const {
            selected,
            available,
            addSelected,
            removeSelected,
            searchHandler,
            title
        } = this.props;

        return (
            <div className={styles.container} data-cy="SwapBox">
                <div className={styles.column} style={{ marginRight: '1rem' }}>
                    <div className={styles.headerWithSearch}>
                        <h2 className={styles.heading} data-cy="SwapBox-title">{title}</h2>
                        <SearchInput
                            handler={searchHandler}
                            title={title} 
                            data-cy="SwapBox-SearchInput"/>
                    </div>
                    <Rows
                        data={available}
                        title={title}
                        handler={addSelected}
                        isSelected={false} />
                </div>
                <div className={styles.column}>
                    <div className={styles.header}>
                        <h2 className={styles.heading} data-cy="SwapBox-Selectedtitle">Selected {title}</h2>
                    </div>
                    <Rows
                        data={selected}
                        title={title}
                        handler={removeSelected}
                        isSelected={true} />
                </div>
            </div>
        );
    }
}

const Rows = ({ data, title, handler, isSelected }) => {
    return (
        <div className={styles.rows}>
            { lodash.isEmpty(data) &&
                <p className={styles.helpText}>
                    { isSelected
                        ? `There are no selected ${title}`
                        : `There are no available ${title}`
                    }
                </p>
            }
            { data.map((item, key) =>
                <div key={`${key}.${item.id}`}
                    className={styles.row}
                    onClick={handler.bind(this, item.id)}>

                    <span className={styles.item}>{item.displayName}</span>

                    {lodash.map(item.details, (text, key) =>
                        <span className={styles.detail} key={`${key}.${text}`}>
                            { text }
                        </span>
                    )}

                    <span className={`${icons.materialIcons} ${styles.actionIcon}`}>
                        { isSelected ? 'clear' : 'add'}
                    </span>
                </div>
            )}
        </div>
    );
};

const SearchInput = ({ handler, title }) => {
    if (!handler) {
        return null;
    }

    return (
        <input
            className={formStyles.inputTextBox}
            type="search"
            placeholder={`Search ${title}`}
            onChange={handler} />
    );
};

const rowShape = {
    id: PropTypes.string,
    displayName: PropTypes.string,
    details: PropTypes.arrayOf(PropTypes.string)
};

SwapBox.propTypes = {
    title: PropTypes.string,
    selected: PropTypes.arrayOf(
        PropTypes.shape(rowShape)
    ),
    available: PropTypes.arrayOf(
        PropTypes.shape(rowShape)
    ),
    addSelected: PropTypes.func.isRequired,
    removeSelected: PropTypes.func.isRequired,
    searchHandler: PropTypes.func
};

export default SwapBox;
